








import { getProjectOperators } from "@/api/gateways/vendor-staff-api";
import SelectOption from "@/common/ui/presenters/select-option";
import VendorStaff from "@/models/vendor-staff";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import { getOperatorFilterOptions } from "@/servicetask/api/service-schedule-list-api";

/**
 * 工程の作業者の選択
 */
@Component({})
export default class OperatorSelect extends Vue {
  @Prop({ required: true }) project!: number; // 現場ID
  @Prop() office?: number; // 所属ID
  @Prop() work?: number; // 業種ID
  @Prop({ default: "" }) value!: string;
  @Prop({ required: false }) taskTypeId!: number;

  operator: string = "";
  operators: VendorStaff[] = [];
  operatorOptions: SelectOption[] = [];

  get options(): SelectOption[] {
    if (this.taskTypeId) {
      return this.operatorOptions;
    } else {
      return this.filteredOperators.map(o => ({
        text: o.name,
        value: String(o.id)
      }));
    }
  }

  private get filteredOperators(): VendorStaff[] {
    let operators = this.operators;
    if (this.office) {
      operators = operatorsOfOffice(operators, this.office);
    }
    if (this.work) {
      operators = operatorsOfWork(operators, this.work);
    }
    return operators;
  }

  @Watch("value", { immediate: true })
  onDefaultValueChanged(value: string) {
    this.operator = value;
  }

  @Watch("project", { immediate: true })
  onProjectChanged(projectId: number) {
    if (this.taskTypeId) {
      this.initOptionsWithStaskID();
    } else {
      this.initOptions(projectId);
    }
  }

  private async initOptions(projectId: number): Promise<void> {
    this.operators = await getProjectOperators({ projectId });
  }

  initOptionsWithStaskID(): void {
    // 工程表に使用されている施工者だけをオプションとして取得する
    getOperatorFilterOptions({
      serviceTaskTypeId: String(this.taskTypeId)
    }).then(options => {
      this.operatorOptions = options;
    });
  }
}

/**
 * 業種で絞り込む
 */
function operatorsOfWork(
  operators: VendorStaff[],
  workTypeId: number
): VendorStaff[] {
  return operators.filter(s => s.workTypeIds.includes(workTypeId));
}

/**
 * 業者で絞り込む
 */
function operatorsOfOffice(
  operators: VendorStaff[],
  officeId: number
): VendorStaff[] {
  return operators.filter(s => s.vendorId === officeId);
}
